const isBrowserFn = () => typeof window !== 'undefined' && Boolean(window.navigator);

export { isBrowserFn };
